export default __webpack_public_path__ + "static/media/bug.204df919.svg";